import { render, staticRenderFns } from "./RecommentsChooseDialog.vue?vue&type=template&id=7af095fe&scoped=true&"
import script from "./RecommentsChooseDialog.vue?vue&type=script&lang=js&"
export * from "./RecommentsChooseDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecommentsChooseDialog.vue?vue&type=style&index=0&id=7af095fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af095fe",
  null
  
)

export default component.exports